import * as React from "react";
import * as S from "@styled";
import { BpmnJsCliWrapper } from "../model/BpmnJsCliWrapper";
import { IElement } from "../model/IProcessData";
import { default as ParameterInput } from "./ParameterInput";
import CustomToggle from "shared/components/CustomToggle";

export const InclusiveConditionBranchEditor: React.FC<InclusiveDescisionProps> = (props) => {
    const handleDefaultBranchChange = (checked: boolean, event: any, id: string) => {
        if (props.element.isDefault !== checked) {
            BpmnJsCliWrapper.toggleDefaultBranch(props.element.id);
        }
    };

    let expressionInput = null;
    if (!props.element.isDefault) {
        expressionInput = <ParameterInput
            name="expression"
            label={FRENDS.Localizations.Expression}
            elementId={props.id}
            value={props.element.parameters["expression"]}
        />;
    }

    return (
        <S.FormGroup id={props.id}>
            {expressionInput}
            <S.FormGroup $inline={true}>
                <S.Label>
                    {FRENDS.Localizations.IsDefaultBranch}
                </S.Label>
                <CustomToggle
                    checked={props.element.isDefault as boolean}
                    onChange={handleDefaultBranchChange}
                    disabled={props.disabled}
                />
            </S.FormGroup>
        </S.FormGroup>
    );
};

interface InclusiveDescisionProps {
    id: string;
    element: IElement;
    disabled?: boolean;
}
